import styled from 'styled-components';
export const Permanent = styled.div `
    width: 100%;
    height: 100%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    position: absolute;
    pointer-events: none;
`;
//# sourceMappingURL=index.js.map